import { forwardRef, PropsWithChildren, Ref } from 'react';

import { Box } from '@mui/material';

import { BaseProps, OrNull } from '../types';

export const Toolbar = forwardRef(({ className, ...props }: PropsWithChildren<BaseProps>, ref: Ref<OrNull<HTMLDivElement>>) => (
  <Box
    {...props}
    ref={ref}
    className={className}
    sx={{
      display: 'flex',
      gap: '10px',
      position: 'relative',
      padding: '10px 0 10px 0',
      borderBottom: '2px solid #eee',
    }}
  />
));

export default Toolbar;
